<div *ngIf="showTrend" class="container-trend" [ngClass]="levelTrendModel[levelTrend].class">
    <div class="item-trend">
        <mat-icon class="icon-trend">{{levelTrendModel[levelTrend].icon}}</mat-icon>
        <p class="text-trend">{{levelTrendModel[levelTrend].text}}</p>
    </div>
</div>

